import { Passport } from 'emrn-hybrid/Passport';
import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

export interface DrawListVo {
  /* 总的次数 */
  drawCnt: number;
  /* 抽奖类型 */
  drawType: number;
}
interface invDrawRequest extends BaseRequest {
  deviceId: string; // 设备ID ,
  consumeCnt?: number; // 抽奖次数 ,
  gtoken: string; // 设备token，即gtoken ,
  invId?: string; // 邀请活动ID ,
  uid?: string; // uid，服务端内部用，不用传 ,
  drawList: DrawListVo[] /*抽奖信息*/;
}

export interface LuckyDrawRspDTO {
  description?: string; //描述 ,
  errorCode?: string; // 兑换错误码 30001:代表用户已经中奖,但是兑奖失败, 用户相应列表没有数据 ,
  giftId?: string; // 礼品编号（特殊编码） ,
  giftValue?: number; // 金额 ,
  hasReward?: boolean; // 判断是否中奖 ,
  pic?: string; //奖品的图片 ,
  points?: number; // 积分值 ,
  rewardId?: string; // 奖品Id ,
  rewardType?: number; // 奖品类型 1: 积分奖品 2: 礼物奖品 ,
  title?: string; // title信息 ,
  userRewardId?: string; // 用户兑奖礼物id
}
export interface DrawListVo {
  consumeTimes: string;
  drawTaskId: string;
}

interface DrawResponseData {
  rewardList: LuckyDrawRspDTO[];
  useCntList: DrawListVo[];
}

interface invDrawResponse extends BaseResponse {
  Data: DrawResponseData;
}

/**
 * 抽奖接口
 * @param params
 * @returns
 */
export async function invDraw(request: invDrawRequest, options?: DsbcApiOptions) {
  let { info: userInfo } = await Passport.getUserInfo();
  request.uid = userInfo?.uid;
  const url = await createDsbcApiUrl('/safe/invMulDraw');
  return DsbcApi.fetch<invDrawResponse>(url, request, true, options);
}
